import React, { useState } from 'react';

const MessageBubble = ({ message: msg, isOwn }) => {
    const [imgError, setImgError] = useState(false);

    const timeStr = msg.createdAt
        ? new Date(msg.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        : '';

    const formatDuration = (s) => {
        if (!s) return '';
        return `${String(Math.floor(s/60)).padStart(2,'0')}:${String(s%60).padStart(2,'0')}`;
    };

    return (
        <div className={`msg-bubble-wrapper ${isOwn ? 'msg-bubble-wrapper--own' : 'msg-bubble-wrapper--other'}`}>
            {!isOwn && (
                <div className="msg-sender-name">{msg.senderName || 'Customer'}</div>
            )}

            <div className={`msg-bubble ${isOwn ? 'msg-bubble--own' : 'msg-bubble--other'}`}>

                {/* Text message */}
                {msg.messageType === 'text' && (
                    <span className="msg-text">{msg.content}</span>
                )}

                {/* Image message */}
                {msg.messageType === 'image' && !imgError && (
                    <a href={msg.content} target="_blank" rel="noopener noreferrer">
                        <img
                            src={msg.content}
                            alt={msg.fileName || 'Image'}
                            className="msg-image"
                            onError={() => setImgError(true)}
                        />
                    </a>
                )}
                {msg.messageType === 'image' && imgError && (
                    <div className="msg-media-error">📷 Image unavailable</div>
                )}

                {/* Audio message */}
                {msg.messageType === 'audio' && (
                    <div className="msg-audio">
                        <div className="msg-audio-icon">🎙️</div>
                        <div className="msg-audio-content">
                            <audio controls src={msg.content} className="msg-audio-player" preload="metadata" />
                            {msg.audioDuration && (
                                <span className="msg-audio-duration">
                                    {formatDuration(msg.audioDuration)}
                                </span>
                            )}
                        </div>
                    </div>
                )}

                <div className="msg-meta">
                    <span className="msg-time">{timeStr}</span>
                    {isOwn && (
                        <span className="msg-status">
                            {msg.readAt ? '✓✓' : msg.deliveredAt ? '✓' : '⏳'}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MessageBubble;
